import { createBlock, defineComponent, openBlock, unref } from "vue";
import { ScalarMarkdown } from "@scalar/components/markdown";
//#region src/views/Chat/Messages/Text.vue?vue&type=script&setup=true&lang.ts
var Text_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "Text",
	props: { messagePart: {} },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(ScalarMarkdown), { value: __props.messagePart.value.text }, null, 8, ["value"]);
		};
	}
});
//#endregion
export { Text_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=Text.vue_vue_type_script_setup_true_lang.js.map